import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  interface Props {
    items: ({ _id: string } | { logo: string })[];
    selectedItem: { _id?: string; logo?: string };
  }

  type Emits = (
    e: "onSelectItem",
    item: { _id?: string; logo?: string }
  ) => void;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSelection',
  props: {
    items: {},
    selectedItem: {}
  },
  emits: ["onSelectItem"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);
  const props = __props;
  const emits = __emit;

  const isButtonClicked = ref(false);
  const itemClicked = ref<{ _id?: string; logo?: string } | null>(null);
  const visibleItems = ref<Props["items"]>(props.items.slice(0, 3)); // Mostrar los primeros tres elementos
  const showMoreButton = ref(false);

  const onSelectItem = (item: { _id?: string; logo?: string }) => {
    if (props.selectedItem?.logo === item.logo) {
      return;
    }

    emits("onSelectItem", item);

    isButtonClicked.value = true;
    itemClicked.value = item;
  };

  const showMoreItems = () => {
    const currentIndex = visibleItems.value.length;
    const remainingItems = props.items.slice(currentIndex);

    visibleItems.value = [...visibleItems.value, ...remainingItems];
    showMoreButton.value = false;
  };

  watch(
    () => props.items,
    () => {
      isButtonClicked.value = false;
      itemClicked.value = null;
    }
  );

  onMounted(() => {
    if (props.items.length > 3) {
      showMoreButton.value = true;
    }
  });

const __returned__ = { isDesktop, props, emits, isButtonClicked, itemClicked, visibleItems, showMoreButton, onSelectItem, showMoreItems, onMounted, ref, watch, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})